<template>
  <Header_en/>
  <a-input-search
      v-model:value="value.item"
      :placeholder="'input search text'"
      enter-button
      @search="search"
      size="large"
      style="padding-top: 15vh; width: 80vw;line-height: 5vh"
      pressEnter="search"
  />
  <div v-if="value.visible" class="result_page">
    <p style="font-size: 1vh">There are {{ result.enterprise.length + result.news.length }} results about "{{ value.item }}"</p>
    <p style="margin-bottom: 0.5vh;background: #7c7cff;color: white;text-align: center">Portfolio</p>
    <div v-if="result.enterprise.length > 0">
      <div style="border-bottom-style: solid; border-color: #cacaca; border-width: 1px"
           v-for="(item, index) in result.enterprise" :key="index" @click="showmodal(index, 'enterprise')">
        <p style="text-indent: 1em;font-size: 2.5vh;margin-bottom: 0.5vh">{{ item.name_en }}</p>
        <p style="font-size: 1.8vh;overflow: hidden;width: 84vw; white-space: nowrap; text-overflow: ellipsis;">
          {{ item.introduction_en[0] }}</p>
      </div>
    </div>
    <div v-else>
      <p>There is no result about "{{ value.item }}"</p>
    </div>
    <p style="margin-bottom: 0.5vh;background: #7c7cff;color: white;text-align: center">News</p>
    <div v-if="result.news.length > 0">
      <div style="border-bottom-style: solid; border-color: #cacaca; border-width: 1px"
           v-for="(item, index) in result.news" :key="index" @click="showmodal(index, 'news')">
        <p style="text-indent: 1em;font-size: 2.5vh;margin-bottom: 0.5vh">{{ item.title }}</p>
        <p style="font-size: 1.8vh;overflow: hidden;width: 84vw; white-space: nowrap; text-overflow: ellipsis;">
          {{ item.summary }}</p>
      </div>
    </div>
    <div v-else>
      <p>There is no result about "{{ value.item }}"</p>
    </div>
  </div>
  <a-modal v-model:visible="modal_enterprise.visible" @click="close"
             :centered="true" :footer="null" :width="'80vw'"
             :destroyOnClose="true" :bodyStyle="{padding: 0}">
      <div v-if="modal_enterprise.picture_owner" class="enterprise_item_detail">
        <a-row>
          <a-col :span="12" style="display: flex">
            <img :src="modal_enterprise.picture_owner">
            <div style="z-index: 2;position: absolute; padding:28vh 3vh">
              <p style="margin: 0; font-size: 28px">{{ modal_enterprise.name }}</p>
              <p>——</p>
              <p style="font-size: 28px">{{ modal_enterprise.owner }}</p>
            </div>
          </a-col>
          <a-col :span="12" style="height: 40vw;">
            <a-row style="height: 30vw; display: flex; align-items: center">
              <div style="text-align: center">
                <a-row style="padding-top: 5vh">
                  <p style="font-size: 32px;color: black;margin-bottom: 0;padding-right: 1vw;display: inline">
                    {{ modal_enterprise.name }}</p>
                  <LinkOutlined v-if="modal_enterprise.site" @click="tosite(modal_enterprise.site)"
                                style="font-size: 26px;text-align: left; color: cornflowerblue;padding-left: 0.5vw;display: inline"/>
                </a-row>
                <p style="color: dimgrey">—————</p>
                <ul style="text-align: center; width: 30vw; margin: 0 5vw;max-height: 15vw;overflow-y: scroll">
                  <li v-for="(item, index) in modal_enterprise.introduction" :key="index"
                      style="text-align: left;font-size: 16px; margin-bottom: 1em">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </a-row>
            <a-row style="height: 10vw;text-align: center">
              <img :src="modal_enterprise.trademark"
                   style="width:250px; height:auto;filter: brightness(100%);">
            </a-row>
          </a-col>
        </a-row>
      </div>
      <div v-else style="height: 80vh;">
        <div style="height: 60vh;display: flex;align-items: center;text-align: center;">
          <div style="width: 80vw">
            <a-row style="padding-top: 5vh;">
              <p style="font-size: 42px;color: black;margin-bottom: 0;padding-right: 1vw;display: inline">
                {{ modal_enterprise.name }}</p>
              <LinkOutlined v-if="modal_enterprise.site" @click="tosite(modal_enterprise.site)"
                            style="font-size: 26px;text-align: left; color: cornflowerblue;padding-left: 0.5vw;display: inline"/>
            </a-row>
            <p style="color: dimgrey">—————</p>

            <ul style="text-align: center; width: 60vw; margin: 0 10vw;overflow-x: hidden; max-height: 35vh;font-size: 16px">
              <li v-for="(item, index) in modal_enterprise.introduction" :key="index"
                  style="text-align: left; font-size: 16px; margin-bottom: 1em">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
        <div style="height: 20vh;text-align: center">
          <img :src="modal_enterprise.trademark"
               style="width:250px; height:auto;filter: brightness(100%);">
        </div>
      </div>
    </a-modal>

  <a-modal v-model:visible="modal_news.visible"
           :centered="true" :footer="null" :width="'100%'"
           :bodyStyle="{'padding-bottom': 0} " :destroyOnClose="true">
    <div class="news_detail">
      <p style="color: blue; font-size: 4vh;margin-bottom: 2vh">{{ modal_news.title }}</p>
      <p style="color: blue;margin-bottom: 1vh">{{ modal_news.date }}</p>
      <p style="color: blue">——</p>
      <p style="height: 50vh;max-height: 50vh;margin-bottom:0;overflow-x: hidden;white-space: pre-line">
        {{ modal_news.introduction }}</p>
    </div>
  </a-modal>


</template>
<script>
import axios from 'axios'
import {reactive,} from 'vue'
import Header_en from "@/components/EN/Header_en";
import {LinkOutlined} from "@ant-design/icons-vue/"

export default {
  name: 'Search_en',
  components: {Header_en, LinkOutlined},
  setup() {
    const value = reactive({
      item: '',
      visible: false,
    })
    const result = reactive({
      enterprise: [],
      news: [],
    })
    const modal_enterprise = reactive({
      visible: false,
      name: '',
      site: '',
      owner: '',
      introduction: '',
      picture_owner: '',
      trademark: '',
    })
    const modal_news = reactive({
      visible: false,
      title: '',
      date: '',
      summary: '',
      introduction: '',
    })
    const close = (e) => {
      console.log(e)
      modal_news.visible = false
      modal_enterprise.visible = false
    }
    const showmodal = (index, category) => {
      if (category === 'enterprise') {
        modal_enterprise.visible = (result.enterprise[index]['status'] !== "perished")
        modal_enterprise.name = result.enterprise[index]['name_en']
        modal_enterprise.site = result.enterprise[index]['site']
        modal_enterprise.owner = result.enterprise[index]['owner_en']
        modal_enterprise.introduction = result.enterprise[index]['introduction_en']
        modal_enterprise.picture_owner = result.enterprise[index]['picture_owner']
        modal_enterprise.trademark = result.enterprise[index]['trademark']
      } else if (category === 'news') {
        modal_news.visible = true
        modal_news.title = result.news[index].title
        modal_news.date = result.news[index].date
        modal_news.summary = result.news[index].summary
        modal_news.introduction = result.news[index].introduction
      }
    }
    const search = () => {
      if (value.item.length > 0) {
        value.visible = true
        let params = new URLSearchParams()
        params.append("value", value.item)
        axios.post('https://sig-china.com:8081/api/search_en/', params)
            .then((res) => {
              console.log(res.data)
              result.enterprise = res.data[0]
              result.news = res.data[1]
              result.enterprise.sort((a, b) => {
                return a['id'] - b['id']
              })
              result.news.sort((a, b) => {
                return a['id'] - b['id']
              })
              for (let i = 0; i < result.enterprise.length; i++) {
                result.enterprise[i]["trademark"] = 'https://sig-china.com' + result.enterprise[i]["trademark"]
                if (result.enterprise[i]["picture_owner"]) {
                  result.enterprise[i]["picture_owner"] = 'https://sig-china.com' + result.enterprise[i]["picture_owner"]
                }
                if (result.enterprise[i]["introduction_en"].indexOf('\r\n') !== -1) {
                let temp = result.enterprise[i]["introduction_en"]
                result.enterprise[i]["introduction_en"] = []
                while (temp.indexOf('\r\n') !== -1) {
                  let pointer = temp.indexOf('\r\n')
                  result.enterprise[i]["introduction_en"].push(temp.slice(0, pointer))
                  temp = temp.slice(pointer + 2,)
                }
                result.enterprise[i]["introduction_en"].push(temp)
              } else {
                result.enterprise[i]["introduction_en"] = [result.enterprise[i]["introduction_en"]]
              }

              }
            })
      }
    }

    return {value, search, result, modal_enterprise, modal_news, showmodal, close}
  }
}
</script>
<style scoped>
.result_page {
  padding-top: 2vh;
  margin: 0 8vw;

}

.result_page p {
  color: #7a7a7a;
  text-align: left;
}

.enterprise_item_detail img {
  width: 100%;
  height: 100%;
  filter: brightness(80%)
}
</style>
